/**
 * Copyright (c) 2015 Guyon Roche
 * LICENCE: MIT - please refer to LICENCE file included with this module
 * or https://github.com/guyonroche/exceljs/blob/master/LICENSE
 */

'use strict';

var utils = require('../../../utils/utils');
var BaseXform = require('../base-xform');

var PageSetupPropertiesXform = module.exports = function () {};

utils.inherits(PageSetupPropertiesXform, BaseXform, {

  get tag() {
    return 'pageSetUpPr';
  },

  render: function render(xmlStream, model) {
    if (model && model.fitToPage) {
      xmlStream.leafNode(this.tag, {
        fitToPage: model.fitToPage ? '1' : undefined
      });
      return true;
    }
    return false;
  },

  parseOpen: function parseOpen(node) {
    if (node.name === this.tag) {
      this.model = {
        fitToPage: node.attributes.fitToPage === '1'
      };
      return true;
    }
    return false;
  },
  parseText: function parseText() {},
  parseClose: function parseClose() {
    return false;
  }
});
//# sourceMappingURL=page-setup-properties-xform.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/exceljs/dist/es5/xlsx/xform/sheet/page-setup-properties-xform.js
// module id = 1208
// module chunks = 0